import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { map } from "rxjs";
import { UserState } from "../../../state/user-state/user.state";

@Component({
  selector: "app-wrong-user-type",
  templateUrl: "./wrong-user-type.component.html",
  styleUrls: ["./wrong-user-type.component.scss"],
})
export class WrongUserTypeComponent implements OnInit {
  store = inject(Store);
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  userType$ = this.store
    .select(UserState.getCurrentUser)
    .pipe(
      map((user) => {
        return user?.userType === "secure-file" ? "SecureFILE" : "SecurePRO";
      })
    );

  routeSpecific: string | null = null;

  ngOnInit(): void {
    this.routeSpecific =
      this.activatedRoute.snapshot.queryParams["routeSpecific"];
  }

  backToDashboard() {
    this.router.navigate(["dashboard"]);
  }
}
